import { useState } from "react";
import axios from "axios";
import { Palmtree, Loader2 } from "lucide-react";
import { inputCls, labelCls, btnPrimary } from "./ui";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const HERO = "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?auto=format&fit=crop&w=1400";

export default function LoqueLogin({ onLogin, tokenKey }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const r = await axios.post(`${API}/auth/login`, { email, password });
      localStorage.setItem(tokenKey, r.data.token);
      onLogin(r.data.user);
    } catch (err) {
      const d = err.response?.data?.detail;
      setError(typeof d === "string" ? d : "E-mail ou senha incorretos");
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-[#FBF8F3]" style={{ fontFamily: "Outfit, sans-serif" }}>
      <div className="hidden lg:block relative">
        <img src={HERO} alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0A66C2]/70 to-transparent" />
        <p className="absolute bottom-12 left-12 right-12 text-white text-3xl font-bold leading-snug" style={{ fontFamily: "Fraunces, serif" }}>
          Suas casas, reservas e hóspedes num só lugar.
        </p>
      </div>
      <div className="flex items-center justify-center p-6">
        <form onSubmit={submit} className="w-full max-w-sm" data-testid="login-form">
          <div className="flex items-center gap-2 mb-10">
            <div className="bg-[#0A66C2] p-2 rounded-xl"><Palmtree className="text-white w-6 h-6" /></div>
            <span className="text-2xl font-extrabold text-[#0A66C2]">Se Hospede <span className="text-[#FFB800]">AKI</span></span>
          </div>
          <h1 className="text-3xl font-bold text-slate-900 mb-1" style={{ fontFamily: "Fraunces, serif" }}>Bem-vindo de volta</h1>
          <p className="text-slate-500 text-sm mb-8">Entre para gerenciar seus imóveis.</p>
          <label className={labelCls}>E-mail</label>
          <input data-testid="login-email-input" type="email" required autoFocus value={email}
            onChange={(e) => setEmail(e.target.value)} className={`${inputCls} mb-4`} placeholder="voce@email.com" />
          <label className={labelCls}>Senha</label>
          <input data-testid="login-password-input" type="password" required value={password}
            onChange={(e) => setPassword(e.target.value)} className={`${inputCls} mb-4`} placeholder="••••••••" />
          {error && <div data-testid="login-error" className="text-sm text-red-700 bg-red-50 border border-red-200 rounded-xl p-2.5 mb-4">{error}</div>}
          <button data-testid="login-submit-button" type="submit" disabled={loading} className={`${btnPrimary} w-full h-12`}>
            {loading && <Loader2 className="w-4 h-4 animate-spin" />} {loading ? "Entrando..." : "Entrar no painel"}
          </button>
          <a href="/" className="block text-center text-sm text-slate-500 hover:text-[#0A66C2] mt-6">← Voltar ao site</a>
        </form>
      </div>
    </div>
  );
}
